import { useSyncExternalStore } from 'react';

/**
 * Đúng/sai của một media query, ĐÚNG NGAY TỪ LẦN VẼ ĐẦU. (`Grid.useBreakpoint()` của Ant Design trả
 * rỗng ở lần vẽ đầu rồi mới cập nhật — trên điện thoại là bố cục máy bàn loé lên một nhịp.)
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', notify);
      return () => list.removeEventListener('change', notify);
    },
    () => window.matchMedia(query).matches,
  );
}

/**
 * Các mốc bề rộng của ứng dụng — trùng mốc `md` / `xl` của Ant Design để `Col`/`Row` và bố cục tự
 * viết đổi dạng ở cùng một chỗ.
 *  - điện thoại  < 768px : menu nằm trong ngăn kéo, bảng không cố định cột;
 *  - hẹp         < 1200px: thanh trên cùng thu gọn (bộ lọc xem vào nút bấm).
 */
export const usePhoneLayout = () => useMediaQuery('(max-width: 767.98px)');
export const useCompactLayout = () => useMediaQuery('(max-width: 1199.98px)');
